module.exports = __webpack_public_path__ + "static/media/stephen-curry.7345ecf2.png";